import { injectIntl } from 'react-intl';
import { ArticleRelations as ArticleRelationsComponent } from './ArticleRelations.component';

export const ArticleRelations = injectIntl(ArticleRelationsComponent);
